import { BlobServiceClient } from '@azure/storage-blob';

const BLOB_STORAGE_CONSTANTS = {
  STORAGE_ACCOUNT: {
    USER_AGREEMENT: `${USER_AGREEMENT_STORAGE_ACCOUNT}`,
    MAINTENANCE: `${MAINTENANCE_STORAGE_ACCOUNT}`,
  },
  CONTAINER: {
    USER_AGREEMENT: 'user-agreement',
    MAINTENANCE: 'maintenance-files',
  },
  BLOB: {
    USER_AGREEMENT: 'user-agreement.html',
    MAINTENANCE: `${ENVIRONMENT_NAME}-maintenance.json`,
  },
};

class BlobHandler {
  private readonly storageAccountUrl: string;
  private blobServiceClient;

  constructor(storageAccountName: string) {
    this.storageAccountUrl = `https://${storageAccountName}.blob.core.windows.net`;
    this.blobServiceClient = new BlobServiceClient(this.storageAccountUrl);
  }

  async getBlob(containerName: string, blobName: string) {
    const containerClient = this.blobServiceClient.getContainerClient(containerName);
    const blobClient = containerClient.getBlobClient(blobName);
    const blobResponse = await blobClient.download();
    return await this.blobToString(await blobResponse.blobBody);
  }

  private async blobToString(blob: Blob | undefined) {
    if (blob) {
      const fileReader = new FileReader();
      return new Promise((resolve, reject) => {
        fileReader.onloadend = (ev: ProgressEvent<FileReader>) => {
          if (ev && ev.target) {
            resolve(ev.target.result);
          } else {
            reject(new Error('Failed to fetch blob from storage.'));
          }
        };
        fileReader.onerror = reject;
        fileReader.readAsText(blob);
      });
    }

    throw new Error('Failed to fetch blob from storage.');
  }
}

export default BlobHandler;
export { BLOB_STORAGE_CONSTANTS };
